<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div class="">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest max-100 text-primary">Subsidieregelingen</h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Gemeentelijke regelingen</h5>
      <div class="d-flex flex-column flex-lg-row justify-content-center">

        <!-- form 1 card -->
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">

          <div v-show="lead.NIP_address">
            <h6 class="pb-3 mt-3 max-100">Verduurzaming en isolatie woningen voor huiseigenaren van max. {{ lead.address.gem_NIP_amount_desc_short }}</h6>
            <div class="small mb-4">
                <checkmark-item v-if="lead.address.gem_NIP_amount_desc_short" class="mb-2" icon="info-circle-fill">
                  Tot {{ lead.address.gem_NIP_amount_desc_short }} per woning voor maatregelen voor verduurzaming.
                </checkmark-item>
                <checkmark-item v-if="maxIncomeDescShort" class="mb-2" icon="info-circle-fill">
                  Voor huishoudens die niet m&eacute;&eacute;r verdienen dan {{ maxIncomeDescShort }}.
                </checkmark-item>
            </div>
          </div>

          <div v-show="!lead.NIP_address">
            <div class="small mb-4">
                <checkmark-item class="mb-2" icon="info-circle-fill">
                  Sommige gemeenten bieden subsidie vanuit het Nationaal Isolatie Programma (NIP).
                </checkmark-item>
                <checkmark-item class="mb-2" icon="info-circle-fill">
                  Nog niet alle gemeenten hebben een regeling voor deze subsidie, maar we vragen wel alvast relevante gegevens.
                </checkmark-item>
            </div>
          </div>
            
            <!-- card with max income -->
            <base-card v-if="maxIncomeNumber"  inner-class="small">
              <strong class="fw-500">
                U mocht in {{ parseInt(new Date().getFullYear()) - 1 }} maximaal {{ maxIncomeDescShort }} verdienen. Dat komt neer op ca.:
              </strong>
              <div class="mt-3 fw-500">
                <span class="fw-600 fs-5 text-info">
                  {{ maxIncomeNumber }}
                </span>
                per jaar (bruto)
              </div>
              <div class="mt-3">
                <i>Dit is het totale <strong class="fw-600">bruto</strong> inkomen van uw <strong class="fw-600">huishouden</strong> bedragen, inclusief vakantiegeld.</i>
              </div>
            </base-card>

            <base-input
              class="mt-3"
              type="radiobuttons" :options="moreLess"
              name="OverMaxIncome"
              v-model:value="lead.financing.nip.OverMaxIncome" :validator="v$.financing.nip.OverMaxIncome">
              Was uw <strong class="fw-600">bruto</strong> inkomen ({{ parseInt(new Date().getFullYear()) - 1 }}) hoger of lager dan de bovenstaande bedragen?
            </base-input>

            <div class="mt-3 mb-5 small">
              <i><strong class="fw-600">Weet u het niet precies?</strong> Maak dan een schatting. We kijken later nogmaals naar uw inkomen v&oacute;&oacute;r we overgaan tot een offici&euml;le aanvraag.</i>
            </div>

            <base-card inner-class="small" color="secondary" v-show="lead.NIP_address">
              <h6>Belangrijkste voorwaarden</h6>
              <!-- <checkmark-item class="mb-2" icon="check-circle-fill" :icon-color="lead.financing.nip.OverMaxIncome === false ? 'success' : 'warning'">
                Het huishouden had in het voorgaande jaar een inkomen dat niet hoger is 125% van het wettelijk minimumloon.
              </checkmark-item> -->
              <checkmark-item v-if="maxIncomeDescShort" class="mb-2" icon="check-circle-fill" :icon-color="lead.financing.nip.OverMaxIncome === false ? 'success' : 'warning'">
                Het huishouden had in het voorgaande jaar een inkomen dat niet hoger is dan <strong class="fw-600">{{ maxIncomeDescShort }}</strong>.
              </checkmark-item>
              <checkmark-item class="mb-2" icon="check-circle-fill" :icon-color="lead.address.BAG_oorspronkelijkBouwjaar__c > 1900 && lead.address.BAG_oorspronkelijkBouwjaar__c < getMaxConstructionYear ? 'success' : 'warning'">
                Bouwjaar v&oacute;&oacute;r <strong class="fw-600">{{ getMaxConstructionYear }}</strong> <span v-show="lead.address.BAG_oorspronkelijkBouwjaar__c">(volgens Kadaster: <strong class="fw-600">{{ lead.address.BAG_oorspronkelijkBouwjaar__c }}</strong>)</span>
              </checkmark-item>
              <checkmark-item class="mb-2" icon="check-circle-fill" :icon-color="lead.NIP_EP_under_max || !lead.address.Energielabel__c ? 'success' : 'warning'">
                <div>
                  Energielabel <strong class="fw-600">{{ lead.address.gem_NIP_max_energielabel ?? 'D' }}</strong> of lager
                </div>
                <div v-if="lead.address.Energielabel__c" class="d-flex mt-2 mb-2">
                  Uw label: <energy-label :label="lead.address.Energielabel__c" />
                </div>
              </checkmark-item>
              <checkmark-item v-if="lead.address.gem_NIP_max_WOZ" class="mb-2" icon="check-circle-fill" :icon-color="'info'">
                De WOZ-waarde van de woning is <strong class="fw-600">&euro; {{ lead.address.gem_NIP_max_WOZ }}</strong> of lager.
              </checkmark-item>
              <div v-if="lead.address.gem_NIP_legal_url" class="mt-2 fst-italic">
                De regeling is te vinden op <a :href="lead.address.gem_NIP_legal_url" target="_blank">{{ legalUrlDomain }}</a>.
              </div>
            </base-card>

            <base-input
              class="mt-5"
              v-if="lead.NIP_potentially_eligible" 
              type="radiobuttons" :options="yesNo"
              name="PermissionToRequestNip"
              v-model:value="lead.financing.nip.PermissionToRequestNip" :validator="v$.financing.nip.PermissionToRequestNip">
              U komt mogelijk in aanmerking. Mogen wij u helpen bij de subsidieaanvraag?
            </base-input>
            <issue-feedback :issue="qualStore.sections.financing.rules.PermissionToRequestNip" />

          </base-form>
        <!-- form card end -->
        </base-card>
      
      <!-- cards wrapper end -->
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.financing.nip.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  // import VariablePill from "@/components/VariablePill.vue"
  import CheckmarkItem from "@/components/CheckmarkItem.vue"
  import IssueFeedback from "@/components/IssueFeedback.vue"
  import EnergyLabel from "@/components/EnergyLabel.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"
  import { civilStatusOptions, ageBrackets, getSocialMinimum } from "@/services/SocialMinimumService"
  // import { getAnnualMinimumWage, getMonthlyMinimumWage } from "@/helpers/MinimumWage"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      // VariablePill,
      CheckmarkItem,
      IssueFeedback,
      EnergyLabel
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        yesNoDontKnow: [
          {
            label: 'Ja',
            value: 'Ja'
          },
          {
            label: 'Nee',
            value: 'Nee'
          },
          {
            label: 'Weet ik niet',
            value: 'Weet ik niet'
          }
        ],
        moreLess: [
          {
            label: '- Lager',
            value: false
          },
          {
            label: 'Hoger +',
            value: true
          },
        ],
        civilStatusOptions: civilStatusOptions,
        ageBrackets: ageBrackets
      };
    },
    computed: {
      socialMinimum() {
        const nipFields = this.lead.financing.nip;
        return getSocialMinimum(nipFields.AgeBracket, nipFields.AgeBracketPartner, nipFields.CivilStatus,  nipFields.HasChildren);
      },
      legalUrlDomain() {
        try {
          return new URL(this.lead.address.gem_NIP_legal_url).hostname.replace('www.', '');
        } catch (e) {
          return '';
        }
      },
      getMaxConstructionYear() {
        return this.lead.address.gem_NIP_max_construction_year || 1994;
      },
      maxIncomeDescShort() {
        if (this.lead.address.gem_NIP_max_income_desc) {
          // if ends on WML or SM, the value before is a number (eg. 125) which is the percentage. WML = Wettelijk Minimum Loon, SM = Sociaal Minimum
          if (this.lead.address.gem_NIP_max_income_desc.endsWith('WML') || this.lead.address.gem_NIP_max_income_desc.endsWith('SM')) {
            return this.lead.address.gem_NIP_max_income_desc.replace(/WML|SM/, '').trim() + '% van het ' + (this.lead.address.gem_NIP_max_income_desc.endsWith('WML') ? 'wettelijk minimumloon' : 'sociaal minimum');
          }
        }
        return null;
      },
      maxIncomeNumber() {
        if (this.lead.address.gem_NIP_max_income) {
          // format the number as currency
          return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }).format(this.lead.address.gem_NIP_max_income);
        }
        return null;
      }
    },
    methods: {
      touchAndValidate() {
        this.v$.ownership.$touch();
        return !this.v$.ownership.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      },
    },
    mounted() {
      // this.presetHigherLower();
      // if not NIP_potentially_eligible, unset answer for PermissionToRequestNip
      if (!this.lead.NIP_potentially_eligible) {
        this.lead.financing.nip.PermissionToRequestNip = null;
      }
    }
  }
</script>

<style lang="scss">
</style>